export default __webpack_public_path__ + "static/whiteclaw-logo-blk-120x120-6858d6a9163751e71623ca190f394bcc.png";